import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpdateProjectModelFieldFormComponent } from './update-project-model-field-form.component';
import { RappiderMonacoEditorModule, RappiderSelectModule, RappiderStringArrayModule, RappiderSwitchModule, RappiderTextboxModule } from '@rappider/rappider-components';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { TranslateModule } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';


@NgModule({
  declarations: [
    UpdateProjectModelFieldFormComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NzFormModule,
    ReactiveFormsModule,
    RappiderTextboxModule,
    NzCollapseModule,
    RappiderStringArrayModule,
    RappiderSwitchModule,
    RappiderMonacoEditorModule,
    TranslateModule,
    NzButtonModule,
    RappiderSelectModule
  ],
  exports: [
    UpdateProjectModelFieldFormComponent
  ]
})
export class UpdateProjectModelFieldFormModule { }
